import { render } from "./ErrorsAlert.vue?vue&type=template&id=5891239a"
import script from "./ErrorsAlert.vue?vue&type=script&lang=js"
export * from "./ErrorsAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__